import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';
import Dropdown from '../../../components/Dropdown';
import withHostContext, {
  trackingCategories,
  trackingLabels,
  trackingLocations,
  trackClick,
  trackEventGa,
} from '../../../context/host/consumer';

import './styles.css';

import { getUrlWithProtocol } from '../../../utils/url';

const messages = defineMessages({
  learnMore: {
    id: 'hubs.weblinks.learn-more',
    defaultMessage: 'Learn More',
  },
  discoverMore: {
    id: 'hubs.weblinks.discover-more',
    defaultMessage:
      'Ready to discover more about <b>{college}</b>? Check out these links!',
  },
});

class LearnMoreLink extends React.PureComponent {
  static propTypes = {
    premium_links: PropTypes.arrayOf(PropTypes.object),
    collegeName: PropTypes.string,
    intl: PropTypes.object,
  };

  state = {
    dropdownOpen: false,
  };

  getHeader = () => {
    return (
      <p className="headerText" data-cy="weblinks-learnmore-header">
        <FormattedMessage
          {...messages.discoverMore}
          values={{ b: (...chunks) => <b>{chunks}</b>, college: this.props.collegeName }}
        />
      </p>
    );
  };

  handleClick = (e) => {
    const productId = e.target.getAttribute('data-click-ppid');
    const location = e.target.getAttribute('data-click-location');
    if (productId && location) {
      trackClick(this.props.hostContext, { productId, location });
    }
    const category = e.target.getAttribute('data-click-category');
    const label = e.target.getAttribute('data-click-label');
    if (category && label) {
      trackEventGa(this.props.hostContext, { type: 'click', category, label });
    }
  };

  handleOpen = (e) => {
    this.setState({ dropdownOpen: true });
    if (!e) {
      return;
    }
    trackEventGa(this.props.hostContext, {
      type: 'click',
      category: trackingCategories.TOP_RIGHT_NAV,
      label: trackingLabels.LEARN_MORE,
    });
  };

  handleClose = () => {
    this.setState({ dropdownOpen: false });
  };

  render() {
    const { premium_links, intl, collegeName } = this.props;
    const { dropdownOpen } = this.state;
    const leanMoreLinks = []
      .concat(premium_links || [])
      .filter((link) => link.category === 'LEARN_MORE');
    const text = intl.formatMessage(messages.discoverMore, {
      b: (...chunks) => chunks,
      college: collegeName,
    });

    return (
      <React.Fragment>
        {leanMoreLinks && leanMoreLinks.length > 0 && (
          <Dropdown
            data-cy="weblinks-learnmore-dropdown"
            aria-label={`Learn more, ${text}`}
            className="learnmore-dropdown"
            icon={`caret ${dropdownOpen ? 'up' : 'down'}`}
            text={this.props.intl.formatMessage(messages.learnMore)}
            onOpen={this.handleOpen}
            onClose={this.handleClose}
          >
            <Dropdown.Menu direction="left">
              <Dropdown.Header content={this.getHeader()} />
              <div className="links-container">
                {leanMoreLinks.map((link, index) => (
                  <a
                    data-cy="weblinks-learnmore-link"
                    key={`${link.topic}-${index}`}
                    className="link-item"
                    target="_blank"
                    rel="noopener noreferrer"
                    href={getUrlWithProtocol(link.url)}
                    role="option"
                    aria-selected="false"
                    data-click-ppid={link.product_id}
                    data-click-location={trackingLocations.LEARN_MORE}
                    data-click-label={`${link.topic}`}
                    data-click-category={trackingCategories.TOP_RIGHT_NAV}
                    onClick={this.handleClick}
                  >
                    {link.topic}
                  </a>
                ))}
              </div>
            </Dropdown.Menu>
          </Dropdown>
        )}
      </React.Fragment>
    );
  }
}

export default injectIntl(withHostContext(LearnMoreLink));
